import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
// import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { validateAddRestDay } from "../../utils/validation";
import CommonTableModule from "../CommonTable/CommonTableModule";
import CommonToast from "../Toaster/CommonToast";
import CommonLoader from "../loaderComponent/CommonLoader";

class AddDaysPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: "",
      restDate: null,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: false,
      categoryDataArray: [],
      projectId: this.props.location.state?.data?.id,
      selectedEmployees: [],
      employeeDataArr: [],
      selectAllChecked: false,
      employeeSearchTerm: ''
    };
  }


  async componentDidMount() {
    this.fetchRestDayData();
    //this.fetchEmployeeData();
  }
  // fetchEmployeeData = () => {
  //   this.setState({ loading: true })
  //   axios({
  //     method: 'get',
  //     url: `/employeeProject/employee/${this.state.projectId}`,
  //     headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  //   })
  //     .then(res => {
  //       console.log("res.data----employee", res.data?.employees);
  //       this.setState({ employeeDataArr: res.data?.employees, loading: false })
  //     })
  //     .catch(err => {
  //       this.setState({ loading: false })
  //       console.log("error is here", err)
  //     })
  // }
  fetchEmployeeData = () => {
    this.setState({ loading: true })
    axios({
      method: 'post',
      url: `/employeeProject/employeerestday`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      data: {
        projectId: this.state.projectId,
        date: this.state.restDate// Ensure this is in 'YYYY-MM-DD' format
      }
    })
      .then(res => {
        console.log("res.data----employee", res.data?.employees);
        this.setState({ employeeDataArr: res.data?.employees, loading: false })
      })
      .catch(err => {
        this.setState({ loading: false })
        console.log("error is here", err)
      })
  }
  fetchRestDayData = () => {
    this.setState({ loading: true })
    console.log('this is props',)

    axios({
      method: 'get',
      url: `/restdays/list/${this.state.projectId}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        // console.log("res.data---->", res.data);
        this.setState({ categoryDataArray: res.data, loading: false })
      })
      .catch(err => {
        this.setState({ loading: false })
        // console.log("error is here", err)
      })
  }
  // handleIndividualCheckboxChange = (e, employeeId) => {
  //   console.log("employeeId", employeeId);
  //   const { selectedEmployees } = this.state;

  //   if (e.target.checked) {
  //     const updated = [...selectedEmployees, employeeId];
  //     this.setState({
  //       selectedEmployees: updated,
  //       selectAllChecked: updated.length === this.state.employeeDataArr.length
  //     });
  //   } else {
  //     const updated = selectedEmployees.filter(id => id !== employeeId);
  //     this.setState({
  //       selectedEmployees: updated,
  //       selectAllChecked: false
  //     });
  //   }
  // };

  handleIndividualCheckboxChange = (e, employeeId) => {
    const { selectedEmployees, employeeDataArr, errors } = this.state;

    let updated;
    if (e.target.checked) {
      updated = [...selectedEmployees, employeeId];
    } else {
      updated = selectedEmployees.filter(id => id !== employeeId);
    }

    this.setState({
      selectedEmployees: updated,
      selectAllChecked: updated.length === employeeDataArr.length,
      errors: {
        ...errors,
        selectedEmployees: updated.length === 0 ? "Please select at least one employee." : "" // Clear or show error
      }
    });
  };




  // handleSelectAllChange = (e) => {
  //   console.log("event", e.target.checked);
  //   if (e.target.checked) {
  //     const allEmployeeIds = this.state.employeeDataArr.map(emp => emp.id);
  //     console.log("allEmployeeIds", allEmployeeIds);
  //     this.setState({
  //       selectedEmployees: allEmployeeIds,
  //       selectAllChecked: true
  //     });
  //   } else {
  //     this.setState({
  //       selectedEmployees: [],
  //       selectAllChecked: false
  //     });
  //   }
  // };

  handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    const { employeeDataArr, employeeSearchTerm } = this.state;

    if (isChecked) {
      // Only select employees who are not on leave and match the search term
      const selectableEmployeeIds = employeeDataArr
        .filter(emp =>
          emp.onLeave !== 1 &&
          emp.fullName.toLowerCase().includes(employeeSearchTerm?.toLowerCase() || '')
        )
        .map(emp => emp.id);

      this.setState({
        selectedEmployees: selectableEmployeeIds,
        selectAllChecked: true
      });
    } else {
      this.setState({
        selectedEmployees: [],
        selectAllChecked: false
      });
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: value.trim() ? "" : prevState.errors[name],
      },
    }));
  };

  // handleDateChange = (date) => {
  //   if (!date) return;
  //   const selectedDate = new Date(date);
  //   selectedDate.setHours(12, 0, 0, 0);
  //   const now = new Date();
  //   now.setHours(0, 0, 0, 0);
  //   const startOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  //   const endOfCurrentMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  //   const isInCurrentMonth = selectedDate >= startOfCurrentMonth && selectedDate <= endOfCurrentMonth;
  //   this.setState((prevState) => ({
  //     restDate: selectedDate,
  //     errors: {
  //       ...prevState.errors,
  //       restDate: isInCurrentMonth ? "" : "Please select a date only from the current month.",
  //     },
  //   }), () => {
  //     if (isInCurrentMonth) {
  //       this.fetchEmployeeData();  // Call API only if date is valid
  //     }
  //   });
  // };

  handleDateChange = (date) => {
    if (!date) return;

    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    const now = new Date();
    now.setHours(0, 0, 0, 0);

    const startOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfCurrentMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    endOfCurrentMonth.setHours(23, 59, 59, 999);

    const isInCurrentMonth =
      selectedDate >= startOfCurrentMonth && selectedDate <= endOfCurrentMonth;

    this.setState(
      (prevState) => ({
        restDate: selectedDate,
        errors: {
          ...prevState.errors,
          restDate: isInCurrentMonth
            ? ""
            : "Please select a date only from the current month.",
        },
      }),
      () => {
        if (isInCurrentMonth) {
          this.fetchEmployeeData();
        }
      }
    );
  };



  onSubmit = async (event) => {
    // debugger
    event.preventDefault();
    this.setState({ hasError: false, errMsg: "", completed: false, loading: true });

    const errors = validateAddRestDay(
      this.state.description,
      this.state.restDate,
      this.state.selectedEmployees
    );

    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }

    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const selectedEmployeeIds = this.state.selectedEmployees;
    // const selectedEmployeeIds = this.state.selectedEmployees.map(option => option.value);

    try {
      const restDayPayload = {
        remarks: this.state.description,
        date: this.state.restDate,
        projectId: this.state.projectId,
        empids: selectedEmployeeIds
      }
      // debugger
      const userResponse = await axios.post("/restdays/add", restDayPayload, { headers });
      // this.setState({ message: userResponse?.data?.message })
      if (userResponse.data?.message === "Rest days are not added as duplicate entries.") {
        this.setState({
          completed: true,
          toastMessage: userResponse?.data?.message,
          toastVariant: 'danger',
          showModal: false,
          color: 'red',
          showToast: true,
          description: "",
          restDate: "",
          selectedEmployees: "",
          errors: {}
        },

        );
      }
      else if (userResponse.status === 200) {
        this.setState({
          completed: true,
          toastMessage: userResponse?.data?.message,
          toastVariant: 'success',
          showModal: false,
          color: 'green',
          showToast: true,
          description: "",
          restDate: "",
          selectedEmployees: "",
          errors: {}
        },
          () => {
            this.setState({
              startDate: "",
              description: '',
              errors: {},
            });
          }
        );
      }
      setTimeout(() => {
        this.setState({
          loading: false, showToast: false
        });
      }, 3000);
      if (this.state.completed) {
        this.fetchRestDayData()
      }
    } catch (error) {
      console.log('error', error.response.data.error);
      this.setState({
        hasError: true,
        toastMessage: error.response.data.error,
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({
          loading: false, showToast: true,
        });
      }, 1000);
      window.scrollTo(0, 0);
    }
  }

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/project-list");
      this.setState({ loading: false });
    }, 900);
  }
  render() {
    const columns = [
      { key: "id", label: "ID" },
      { key: "project_id", label: "Project ID" },
      { key: "empid", label: "EMP ID" },
      { key: "fullName", label: "Name" },
      { key: "date", label: "Date" },
      { key: "remarks", label: "Description" }
    ]
    return (
      <div className="container-fluid pt-4">
        <CommonLoader isLoading={this.state.loading}>
          <CommonToast
            show={this.state.showToast}
            onClose={() => this.setState({ showToast: false })}
            message={this.state.toastMessage}
            variant={this.state.toastVariant}
            color={this.state.color}
          />

          <Card className="shadow-sm rounded border-0">
            <Card.Header className="text-white">
              <b> Add Rest Days</b>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={this.onSubmit}>
                <div className="row">
                  <div className="col-sm-12">
                    <Row className="mb-3">
                      {/* Description */}
                      <Col md={4}>
                        <Form.Group controlId="formDescription">
                          <Form.Label className="text-muted required">Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={1}
                            name="description"
                            value={this.state.description || ""}
                            placeholder="Description"
                            onChange={this.handleChange}
                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.description && (
                            <small className="text-danger">{this.state.errors.description}</small>
                          )}
                        </span>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Rest Date</Form.Label>
                          <DatePicker
                            selected={this.state.restDate}
                            className="form-control"
                            onChange={this.handleDateChange}
                            placeholderText="Select Rest Date"
                            minDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
                            maxDate={new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)}
                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.restDate && (
                            <small className="text-danger">{this.state.errors.restDate}</small>
                          )}
                        </span>
                      </Col>

                      <Col md={4}>
                        <Form.Group controlId="formEmployeeSelection">
                          <Form.Label className="text-muted required">Select Employee(s)</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Search employee..."
                            value={this.state.employeeSearchTerm}
                            onChange={(e) => this.setState({ employeeSearchTerm: e.target.value })}
                            className="mb-2"
                          />
                          <Form.Check
                            type="checkbox"
                            id="select-all"
                            label="Select All"
                            placeholder="Search employee..."
                            value={this.state.employeeSearchTerm}
                            checked={this.state.selectAllChecked}
                            onChange={this.handleSelectAllChange}
                            className="mb-2"
                          />
                          <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #dee2e6', padding: '8px', borderRadius: '4px' }}>
                            {/* {this.state.employeeDataArr?.map((employee) => ( */}
                            {this.state.employeeDataArr
                              ?.filter(emp =>
                                emp.fullName.toLowerCase().includes(this.state.employeeSearchTerm?.toLowerCase() || '')
                              )
                              .map((employee) => (
                                <Form.Check
                                  key={employee.id}
                                  type="checkbox"
                                  id={`emp-${employee.id}`}
                                  label={
                                    employee.onLeave === 1
                                      ? `${employee.fullName} (On Leave)`
                                      : employee.fullName
                                  }
                                  value={employee.id}
                                  checked={this.state.selectedEmployees.includes(employee.id)}
                                  onChange={(e) => this.handleIndividualCheckboxChange(e, employee.id)}
                                  disabled={employee.onLeave === 1} // ❗ Disable if restday
                                />
                              ))}
                          </div>
                          {this.state.errors.selectedEmployees && (
                            <div className="invalid-feedback d-block">
                              {this.state.errors.selectedEmployees}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="add-cancel-btn">
                  <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                    {this.state.editAction ? "Update " : "Add"}
                  </Button>
                  <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>

          <CommonTableModule columns={columns} data={this.state.categoryDataArray} />
        </CommonLoader>
      </div>
    );
  }
}

export default AddDaysPage;
